import type { NeoRmaItem } from "@expert/types";
import { getExpUserProfile } from "~/composables/ExpApi/expUser";

export enum ReturnReason {
  /**
   * damaged by transport
   */
  TRANSPORT_DAMAGE,
  ARTICLE_DEFECT,

  /**
   * article does not look like described
   */
  LOOK,

  /**
   * customer dislike article
   */
  DISLIKE,

  /**
   * wrong article
   */
  WRONG_ARTICLE_DELIVERED,

  /**
   * article delivery was to late
   */
  LATE,
  INCOMPLETE,
  CANCEL
}

export enum ReturnHandlingType {
  /**
   * Credit the customer an amount.
   */
  CREDIT,
  /**
   * Refund the customer an amount to the original payment method.
   */
  REFUND,
  /**
   * Send the customer a replacement.
   */
  EXCHANGE,
  /**
   * Repair the item and send back to the customer.
   */
  REPAIR,
  /**
   * Dead on arrival.
   */
  DOA,
  UNKNOWN
}

export const startAnonymousRma = async (email: string, orderId: string, captcha: string): Promise<{orderId: string, loginPerformed: boolean} | null> => {
	const csrf = useCurrentUserState().value?.csrfToken;
	if (!csrf) {
        throw new Error('Missing csrf token in startAnonymousRma call');
    }

    try {
        const data = await $fetch('/api/neo/frontend/_api/returns/startAnonymousRma', {
            headers: {
                'bt-use-user-auth': 'true',
                'csrf-token': csrf
            },
            method: 'POST',
            credentials: "include",
            body: {
                email: email,
                externalReference: orderId,
                captcha: captcha,
            },
        });

        await getExpUserProfile();

        return data;
    } catch (error) {
        throw new Error("Error starting anonymous Rma", { cause: error });
    }
}

export const startReturn = async (orderId: string, items: NeoRmaItem[]): Promise<Array<NeoRmaItem>> => {
    return $fetch('/api/return/startReturn', {
        method: 'POST',
        query: {
            orderId: orderId,
        },
        body: {
            items: items,
        },
    });
};